export const PRODUCT_HARD_HOOK_TYPE = 1;
export const PRODUCT_SOFT_HOOK_TYPE = 2;
export const PRODUCT_DICOUNT_HOOK_TYPE = 3;
export const PRODUCT_SET_HOOK_TYPE = 4;